export default __webpack_public_path__ + "static/media/arrow-applicant.07fca9e2.svg";